import { FoodForkDrinkIcon } from './FoodForkDrinkIcon';

/**
 * author: Google
 * id 4CE93EC4-0938-4CB2-AB0E-0DCA0AF27B91
 * name food-fork-drink
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-fork-drink.svg
 * tags
 * - Food / Drink 
 */
export const FoodForkCupIcon = FoodForkDrinkIcon;
export default FoodForkCupIcon